const social = {
  yelp: "https://www.yelp.com/biz/side-street-cafe-newbury-park",
  google:
    "https://www.google.com/maps/place/Side+Street+Cafe/@34.1926667,-118.929348,17z/data=!3m1!5s0x80e8309687d1ca2d:0xd4bb9d5844d69703!4m8!3m7!1s0x80e83097bf7e226f:0x74efb6209b14f06a!8m2!3d34.1926667!4d-118.929348!9m1!1b1!16s%2Fg%2F1t_kgvg_?entry=ttu&g_ep=EgoyMDI1MDEyOS4xIKXMDSoASAFQAw%3D%3D",
  instagram: "https://www.instagram.com/sidestreetcafe805/",
  facebook: "https://www.facebook.com/people/Side-Street-Cafe/100057583961043/",

  nextdoor: "https://nextdoor.com/pages/side-street-cafe-newbury-park-ca/",
};

export default social;
